import { render, staticRenderFns } from "./DetailCriticismFileDialog.vue?vue&type=template&id=46a12d82&"
import script from "./DetailCriticismFileDialog.vue?vue&type=script&lang=js&"
export * from "./DetailCriticismFileDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports